module.exports = __webpack_public_path__ + "99e700982e86cbc8706d3ecc9b4efa81.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/containers/Help/screenshots/Wizard Page (3).png
// module id = 1046
// module chunks = 0